import { Demo } from '@/types';
import { Matchdata } from '@/types/match';

export const generateDemoDownloadLink = (
  demo: Demo[],
  match: Matchdata,
  mapNumber: number,
): string => {
  if (demo.length > 0 && demo[mapNumber]?.demo.indexOf('public') !== -1) {
    return `/demos/${demo[mapNumber].demo.replace('public/', '')}`;
  } else {
    return `/demos/${match.id}_map${mapNumber + 1}_${
      match.get5StatsMatch.get5StatsMaps[mapNumber].mapname
    }.dem`;
  }
};
